import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-21f39d46")

_pushScopeId("data-v-21f39d46")
const _hoisted_1 = { class: "r-item" }
const _hoisted_2 = { class: "base-data df-middle" }
const _hoisted_3 = { style: {"min-width":"18px","max-width":"18px"} }
const _hoisted_4 = { class: "icon-wrap ml-16" }
const _hoisted_5 = { class: "nickname f-bold f-md" }
const _hoisted_6 = { class: "df-middle price" }
const _hoisted_7 = {
  key: 0,
  class: "more-data br-lg d-f f-md px-16 pt-16 pb-8"
}
const _hoisted_8 = { class: "left flex-2" }
const _hoisted_9 = { class: "mb-8" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Symbol")
const _hoisted_11 = { class: "value" }
const _hoisted_12 = { class: "mb-8" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Margin")
const _hoisted_14 = { class: "mb-8" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Entry Price")
const _hoisted_16 = { class: "value" }
const _hoisted_17 = { class: "mb-8" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Close Price")
const _hoisted_19 = { class: "value" }
const _hoisted_20 = { class: "right flex-3 pl-8" }
const _hoisted_21 = { class: "mb-8" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode("Direction")
const _hoisted_23 = { class: "mb-8" }
const _hoisted_24 = /*#__PURE__*/_createTextVNode("Profit%")
const _hoisted_25 = { class: "mb-8" }
const _hoisted_26 = /*#__PURE__*/_createTextVNode("Entry Time")
const _hoisted_27 = { class: "value f-xs" }
const _hoisted_28 = { class: "mb-8" }
const _hoisted_29 = /*#__PURE__*/_createTextVNode("Close Time")
const _hoisted_30 = { class: "value f-xs" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Pic = _resolveComponent("Pic")
  const _component_ColorText = _resolveComponent("ColorText")
  const _component_money = _resolveComponent("money")
  const _component_t = _resolveComponent("t")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("span", _hoisted_3, _toDisplayString(_ctx.item.rankNum), 1),
      _createVNode("div", _hoisted_4, [
        _createVNode(_component_Pic, {
          src: _ctx.item.avatarPic,
          fallback: "/img/user/Avatar@2x.png",
          width: "32",
          height: "32",
          style: {"object-fit":"contain","border-radius":"50%"}
        }, null, 8, ["src"]),
        (_ctx.item.rankNum === 1)
          ? (_openBlock(), _createBlock(_component_Pic, {
              key: 0,
              src: "rank/crown",
              width: "16",
              height: "16",
              class: "crown"
            }))
          : _createCommentVNode("", true)
      ]),
      _createVNode("div", {
        class: "l-right flex-1 ml-16 df-middle df-between",
        style: _ctx.showMore?'':'border-bottom: 1px solid var(--color-border)'
      }, [
        _createVNode("span", _hoisted_5, _toDisplayString(_ctx.item.nickName), 1),
        _createVNode(_component_ColorText, {
          class: "flex-1 pl-12 f-bold",
          value: _ctx.item.profitability
        }, {
          default: _withId(({value}) => [
            _createTextVNode(_toDisplayString(_ctx.item.profitability) + "% ", 1)
          ]),
          _: 1
        }, 8, ["value"]),
        _createVNode("div", _hoisted_6, [
          _createVNode(_component_Pic, {
            src: "rank/coupon",
            width: "16",
            height: "16",
            class: "crown"
          }),
          _createVNode(_component_money, {
            v: _ctx.item.voucherAmount,
            class: "ml-4 price-text"
          }, null, 8, ["v"]),
          _createVNode("div", {
            class: "toggle-wrap df-middle",
            style: {"justify-content":"flex-end"},
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.HandleTaggle && _ctx.HandleTaggle(...args)))
          }, [
            _createVNode(_component_Pic, {
              src: _ctx.showMore?'rank/fold_up':'rank/expand',
              width: "16",
              height: "16",
              class: "crown"
            }, null, 8, ["src"])
          ])
        ])
      ], 4)
    ]),
    (_ctx.showMore)
      ? (_openBlock(), _createBlock("div", _hoisted_7, [
          _createVNode("div", _hoisted_8, [
            _createVNode("p", _hoisted_9, [
              _createVNode(_component_t, {
                path: "leaderboard_3",
                class: "mr-4 c-title"
              }, {
                default: _withId(() => [
                  _hoisted_10
                ]),
                _: 1
              }),
              _createVNode("span", _hoisted_11, _toDisplayString(_ctx.prop('contactCode', _ctx.item)), 1)
            ]),
            _createVNode("p", _hoisted_12, [
              _createVNode(_component_t, {
                path: "leaderboard_5",
                class: "mr-4 c-title"
              }, {
                default: _withId(() => [
                  _hoisted_13
                ]),
                _: 1
              }),
              _createVNode(_component_money, {
                v: _ctx.prop('amount', _ctx.item)
              }, null, 8, ["v"])
            ]),
            _createVNode("p", _hoisted_14, [
              _createVNode(_component_t, {
                path: "leaderboard_7",
                class: "mr-4 c-title"
              }, {
                default: _withId(() => [
                  _hoisted_15
                ]),
                _: 1
              }),
              _createVNode("span", _hoisted_16, _toDisplayString(_ctx.prop('createPrice', _ctx.item)), 1)
            ]),
            _createVNode("p", _hoisted_17, [
              _createVNode(_component_t, {
                path: "leaderboard_9",
                class: "mr-4 c-title"
              }, {
                default: _withId(() => [
                  _hoisted_18
                ]),
                _: 1
              }),
              _createVNode("span", _hoisted_19, _toDisplayString(_ctx.prop('closePrice', _ctx.item)), 1)
            ])
          ]),
          _createVNode("div", _hoisted_20, [
            _createVNode("p", _hoisted_21, [
              _createVNode(_component_t, {
                path: "leaderboard_4",
                class: "mr-4 c-title"
              }, {
                default: _withId(() => [
                  _hoisted_22
                ]),
                _: 1
              }),
              _createVNode(_component_t, { custom: "" }, {
                default: _withId(({td, t}) => [
                  _createVNode(_component_ColorText, {
                    class: "f-medium",
                    display: [t('symbol_10') || 'Sell', t('symbol_9') || 'Buy'],
                    value: _ctx.prop('type', _ctx.item) - 2
                  }, null, 8, ["display", "value"])
                ]),
                _: 1
              })
            ]),
            _createVNode("p", _hoisted_23, [
              _createVNode(_component_t, {
                path: "leaderboard_6",
                class: "mr-4 c-title"
              }, {
                default: _withId(() => [
                  _hoisted_24
                ]),
                _: 1
              }),
              _createVNode(_component_ColorText, {
                class: "value",
                value: _ctx.item.profitability
              }, {
                default: _withId(({value}) => [
                  _createTextVNode(_toDisplayString(_ctx.item.profitability) + "% ", 1)
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _createVNode("p", _hoisted_25, [
              _createVNode(_component_t, {
                path: "leaderboard_8",
                class: "mr-4 c-title"
              }, {
                default: _withId(() => [
                  _hoisted_26
                ]),
                _: 1
              }),
              _createVNode("span", _hoisted_27, _toDisplayString(_ctx.prop('createTime', _ctx.item)), 1)
            ]),
            _createVNode("p", _hoisted_28, [
              _createVNode(_component_t, {
                path: "leaderboard_10",
                class: "mr-4 c-title"
              }, {
                default: _withId(() => [
                  _hoisted_29
                ]),
                _: 1
              }),
              _createVNode("span", _hoisted_30, _toDisplayString(_ctx.prop('closeTime', _ctx.item)), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
})